import { Box } from '@mui/material';

export function TabsHeader(props) {
  return (
    <Box sx={{ display: 'flex' }}>
      <Box
        sx={{
          display: 'flex',
          position: 'relative',

          '&::before': {
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            content: '""',
            zIndex: -1,
            boxShadow: 4,
            borderTopRightRadius: 5,
            borderTopLeftRadius: 5,
            borderBottom: 1,
            borderColor: 'divider',
          },
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
}
